import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Button, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import RemoteAutocomplete from '../components/RemoteAutocomplete';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '0 0 12px 12px',
        margin: '0 1rem 1rem 1rem',
        [theme.breakpoints.down('sm')]: {
            padding: '1rem',
            margin: 0,
        },
        [theme.breakpoints.up('sm')]: {
            border: '1px solid #D8D8D8',
        },
    },
}));

const TripLineSet = ({ data: trip, onChange }) => {
    const classes = useStyles();

    const handleRouteSetChange = (ev, value) => {
        onChange({ ...trip, vehicle_route_set: value, _changed: true });
    };

    return (
        <Box className={classes.root}>
            <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">Line Set</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <RemoteAutocomplete
                        resource="route_set"
                        urlSuffix={null}
                        label="Select Route Set"
                        variant="filled"
                        size="small"
                        value={trip.vehicle_route_set || null}
                        onChange={handleRouteSetChange}
                        getOptionLabel={(opt) => opt.name || ''}
                    />
                </Grid>
                <Grid item xs={12} md={6} container alignItems="center">
                    <Button
                        variant="outlined"
                        disabled={!trip.vehicle_route_set?.id}
                        startIcon={<OpenInNewIcon />}
                        onClick={() => window.open(`/route_set/${trip.vehicle_route_set.id}/edit`, '_blank')}
                    >
                        Edit selected set
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TripLineSet;
